import { render } from "./App.vue?vue&type=template&id=c677441c"
import script from "./App.vue?vue&type=script&language=ts&lang=js"
export * from "./App.vue?vue&type=script&language=ts&lang=js"

import "./App.vue?vue&type=style&index=0&id=c677441c&lang=scss"
script.render = render

export default script